import React from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    padding: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(1.5)
    }
  };
});

const SupportTileBody: React.FC<TypographyProps> = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.padding} variant="body1" {...rest}>
      {children}
    </Typography>
  );
};

export default SupportTileBody;
